/**
 * Media Layer Constants
 */

/** Placeholder image URL for audio files without a cover image */
export const AUDIO_FILE_PLACEHOLDER = 'https://storage.googleapis.com/revex-membership-production/assets/audio-placeholder.svg'

/** Default thumbnail for audio lessons in fullSize mode */
export const AUDIO_LESSON_THUMBNAIL = 'https://storage.googleapis.com/revex-membership-staging/assets/audio-lesson-thumbnail.webp'

/** Base URL for Firebase Storage (used to detect and skip Firebase Storage URLs in CDN replacement) */
export const FIREBASE_STORAGE_BASE_URL = 'https://firebasestorage.googleapis.com'
